import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import merge from 'deepmerge'
import { dirname } from 'path'

import './theme.css'

export const letsgotheme: BrandTheme = merge<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'LETS_GO',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'letsgo',
      height: 28,
    },
  },
)
export default letsgotheme
